import { createTypes, createActions, createReducer } from '@fe/redux/reducers/util'

import _ from 'lodash/fp'

const namespace = 'auth'

const typeKeys = [
  'BOOTSTRAP_REQUEST',
  'BOOTSTRAP_DONE',
  'SET_TOKEN',
  'LOGIN_REQUEST',
  'LOGIN_SUCCESS',
  'LOGIN_ERROR',
  'LOGIN_REQUEST_DONE',
  'LOGOUT',
  'RENEW_SESSION_REQUEST',
  'RENEW_SESSION_SUCCESS',

  'LOADING_BEGIN',
  'LOADING_DONE'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

// state partition when there is no token
const noToken = {
  token: null,
  tokenExpiredAt: null
}

export const initialState = {
  ...noToken,
  loading: false,
  error: null,
  loginRequestWaiting: false,
  bootstrapped: false
}

const reducer = {
  [types.LOADING_BEGIN]: _p => _.set('loading', true),
  [types.LOADING_DONE]: _p => _.set('loading', false),
  [types.BOOTSTRAP_DONE]: p => _.set('bootstrapped', true),
  [types.LOGIN_REQUEST]: p => _.set('loginRequestWaiting', true),
  [types.SET_TOKEN]: p => _.flow(
    _.set('token', p.token),
    _.set('tokenExpiredAt', p.expired_at)
  ),
  [types.LOGIN_REQUEST_DONE]: p => _.set('loginRequestWaiting', false),
  [types.LOGIN_SUCCESS]: p => _.flow(
    _.set('token', p.token),
    _.set('tokenExpiredAt', p.expired_at),
    _.unset('error')
  ),
  [types.LOGOUT]: p => _.flow(
    _.set('token', null),
    _.set('tokenExpiredAt', null),
    _.unset('error'),
    _.unset('profile')
  ),
  [types.LOGIN_ERROR]: p => s => {
    if (p.avoidRedirects) {
      return {
        ...s,
        error: p.error || true
      }
    } else {
      return {
        ...s,
        ...noToken,
        error: p.error || true
      }
    }
  },
  [types.RENEW_SESSION_SUCCESS]: p => _.set('tokenExpiredAt', p.expired_at)
}

export default createReducer(initialState, reducer)

function createSelectors () {
  const auth = _.get(namespace)
  const token = _.flow(auth, _.get('token'))
  const notBootstrapped = _.flow(auth, _.get('bootstrapped'), _.eq(false))
  const notLoggedIn = _.flow(token, _.isNil)
  const loggedIn = _.flow(token, _.negate(_.isNil))
  const error = _.flow(auth, _.get('error'))
  const isLoading = _.flow(auth, _.get('loading'))
  const isWaiting = _.flow(auth, _.get('loginRequestWaiting'))
  return {
    auth,
    token,
    notBootstrapped,
    notLoggedIn,
    loggedIn,
    error,
    isLoading,
    isWaiting
  }
}

export const selectors = createSelectors()
